import Track from "@/utils/track";
import useNavigation from "@/utils/useNavigate";
import { TrackDataContext } from "@akc/mx-taro-h5-components";
import { DotLoading, Empty } from "antd-mobile";
import { RightOutline } from "antd-mobile-icons";
import React, { useContext, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import styles from "./index.module.less";
import useReport from "./useReport";

const InternetReport: React.FC = () => {
  const track = Track();
  const { navigate2H5 } = useNavigation();
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const { setTrackData } = useContext(TrackDataContext);
  const [search] = useSearchParams();

  // 使用 hooks 获取报送列表数据
  const { reportList, loading, error } = useReport();

  useEffect(() => {
    const pageTitle = "互联网报送查询";
    document.title = pageTitle;
    setTrackData({
      page_name: pageTitle,
    });
    track.track("$pageview", {
      page_name: pageTitle,
      previous_page_name: search.get("page_name") || "",
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 点击发送报告
  const handleSendReport = () => {
    // TODO: 实现发送报告逻辑
    console.log("报送公告");
    navigate2H5("https://h5.aikucun.com/p/Q96S6g0AE.html");
  };

  // 点击政策说明
  const handlePolicyExplanation = () => {
    // TODO: 跳转到政策说明页面
    console.log("政策说明");
    navigate2H5("https://h5.aikucun.com/p/r76Csb4w_.html");
  };

  return (
    <div className={styles.reportWrapper}>
      {/* 顶部导航项 */}
      <div className={styles.navSection}>
        <div className={styles.navItem} onClick={handleSendReport}>
          <div className={styles.navItemIcon}>
            <img
              src="https://akim-oss.aikucun.com/4d134bc072212ace2df385dae143139da74ec0ef_1762937377037_4.png"
              width={24}
              height={24}
              alt="mail"
            />
          </div>
          <span className={styles.navItemText}>报送公告</span>
          <RightOutline className={styles.navItemArrow} />
        </div>
      </div>
      <div className={styles.navSection}>
        <div className={styles.navItem} onClick={handlePolicyExplanation}>
          <div className={styles.navItemIcon}>
            <img
              src="https://akim-oss.aikucun.com/f6e1126cedebf23e1463aee73f9df08783640400_1762937377567_18.png"
              width={24}
              height={24}
              alt="mail"
            />
          </div>
          <span className={styles.navItemText}>政策说明</span>
          <RightOutline className={styles.navItemArrow} />
        </div>
      </div>

      {/* 报送信息列表 */}
      <div className={styles.reportList}>
        {loading ? (
          <div className={styles.loadingWrapper}>
            <DotLoading color="primary" />
            <span className={styles.loadingText}>加载中...</span>
          </div>
        ) : error ? (
          <div className={styles.errorWrapper}>
            <Empty description={error} />
          </div>
        ) : reportList.length === 0 ? (
          <div className={styles.emptyWrapper}>
            <Empty description="暂无报送记录" />
          </div>
        ) : (
          reportList.map((item, index) => (
            <div key={index} className={styles.reportCard}>
              <div className={styles.reportItem}>
                <span className={styles.reportLabel}>报送时间：</span>
                <span className={styles.reportValue}>{item.filingTimeStr}</span>
              </div>
              <div className={styles.reportItem}>
                <span className={styles.reportLabel}>业务时间：</span>
                <span className={styles.reportValue}>{item.filingPeriodStr}</span>
              </div>
              <div className={styles.reportItem}>
                <span className={styles.reportLabel}>报送金额：</span>
                <span className={styles.reportValue}>{item.filingAmountStr}</span>
              </div>
              <div className={styles.reportItem}>
                <span className={styles.reportLabel}>报送实名名称：</span>
                <span className={styles.reportValue}>{item.name}</span>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default InternetReport;
